var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentVisibled),expression:"currentVisibled"}],class:_vm.listItemClasses,on:{"click":function($event){$event.stopPropagation();return _vm.fireClick($event)}}},[_vm._ssrNode("<a>","</a>",[_vm._t("default",[_vm._v(_vm._s(_vm.currentLabel))])],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780e04e7","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/list/list-item.vue
// module id = 361
// module chunks = 0 1 7 10 11 18